'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _maintenanceAdminList = require('./maintenance-admin-list.component');

var _maintenanceAdminList2 = _interopRequireDefault(_maintenanceAdminList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.maintenanceAdminList', []).component('maintenanceAdminList', _maintenanceAdminList2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/maintenance-admin-list/maintenance-admin-list.module.js